<template>
  <div class="run-schedule-direction">
    <city-autocomplete
      v-if="!hideSelect"
      v-model="guid"
      :label="title"
      large
      @change="onChange"
    />
    <div v-else class="mb-20 flex flex-align-items-center">
      <div class="red-dot" /> {{ info }}
    </div>
    <div v-if="filialText" class="mt-20 mb-20 text-body color-low">
      <vz-icon
        name="alert-circle-outline"
        variant="low"
        size="18"
      />
      {{ filialText }}
    </div>
    <vz-warning-text v-if="isFake" class="mt-30">
      <span v-html="fakeLocationText" />
    </vz-warning-text>
    <template v-else-if="!hasFake">
      <div class="run-schedule-direction-delivery mt-30">
        <vz-row class="run-schedule-direction-delivery-header">
          <vz-col class="text-medium color-dark">
            Филиал
          </vz-col>
          <vz-col v-for="day in week" :key="day" class="text-medium color-low">
            {{ day }}
          </vz-col>
        </vz-row>
        <vz-row v-for="item in schedule" :key="item.address">
          <vz-col>
            {{ item.address }}
          </vz-col>
          <vz-col v-for="day in item.schedule" :key="day.title" class="color-dark text-medium">
            <div>{{ getTime(day.time) }}</div>
            <span>{{ getDescription(day.time, day.description) }}</span>
          </vz-col>
        </vz-row>
        <run-schedule-direction-skeleton v-if="!schedule.length" :is-dispatch="isDispatch" />
      </div>
      <div v-for="item in schedule" :key="item.address" class="run-schedule-direction-delivery-mobile">
        <vz-row class="run-schedule-direction-delivery-header">
          <vz-col col="3" class="text-medium color-dark">
            Филиал
          </vz-col>
          <vz-col col="9" class="flex-align-self-center color-low">
            {{ item.address }}
          </vz-col>
        </vz-row>
        <vz-row>
          <vz-col v-for="(day, index) in item.schedule" :key="day.title" class="color-dark text-medium">
            <div class="mb-20 color-low">{{ week[index] }}</div>
            <div>
              {{ getTime(day.time) }}
              <span>{{ getDescription(day.time, day.description) }}</span>
            </div>
          </vz-col>
        </vz-row>
      </div>
      <run-schedule-direction-mobile-skeleton v-if="!schedule.length" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { Location } from '~/types/types'
import { useCityStore } from '~/stores/city'
import CityAutocomplete from '~/components/autocomplete/city-autocomplete.vue'
import RunScheduleDirectionSkeleton from '~/components/public/run-schedule/run-schedule-direction-skeleton.vue'
import RunScheduleDirectionMobileSkeleton from '~/components/public/run-schedule/run-schedule-direction-mobile-skeleton.vue'
import VzWarningText from '~/components/ui-kit/vz-warning-text.vue';
import {fakeLocationText} from '~/common/objects';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  isDispatch: {
    type: Boolean,
    default: false
  },
  filial: {
    type: Object as PropType<Location>,
    default: () => ({})
  },
  schedule: {
    type: Array,
    default: []
  },
  hideSelect: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  'change-city'
])

const { setFrom, setTo } = useCityStore()

const { from, to } = storeToRefs(useCityStore())
const week = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']

const guid = computed(() => {
  return props.isDispatch ? from.value.guid : to.value.guid
})

const isFake = computed(() => {
  return props.isDispatch ? Number(from.value?.fake) === 1 : Number(to.value?.fake) === 1
})

const hasFake = computed(() => {
  return Number(from.value?.fake) === 1 || Number(to.value?.fake) === 1
})

const filialText = computed(() => {
  return props.filial?.name ? `Ближайший филиал в г. ${props.filial.name}` : ''
})

const info = computed(() => props.isDispatch ? `Отправление ${from.value.name}` : `Прибытие ${to.value.name}`)

function getTime (time: string): string {
  return time === '00:00' ?  '-' : time
}

function getDescription (time: string, description: string): string {
  return time === '00:00' ?  '' : description
}

function onChange (city: string, location: Location) {
  if (props.isDispatch) {
    setFrom(location)
  } else {
    setTo(location)
  }
  emit('change-city')
}
</script>
